export default __webpack_public_path__ + "static/media/record.5faaca74.svg";